import { z } from "zod";

/** One stored version of a project's instructions. Versions are never edited or deleted. */
export const instructionSchema = z.object({
  id: z.uuid(),
  projectId: z.uuid(),
  version: z.number().int().min(1),
  body: z.string().min(1),
  authorId: z.uuid().nullable(),
  authorName: z.string().nullable(),
  createdAt: z.iso.datetime(),
});
export type Instruction = z.infer<typeof instructionSchema>;

export const instructionListSchema = z.array(instructionSchema);
export type InstructionList = z.infer<typeof instructionListSchema>;

/** A new instructions body. Stored redacted; every save creates a new version. */
export const saveInstructionSchema = z.object({
  body: z.string().trim().min(1).max(8000),
});
export type SaveInstruction = z.infer<typeof saveInstructionSchema>;

/** Restoring a version saves its body as a new version; history is append-only. */
export const restoreInstructionSchema = z.object({
  version: z.number().int().min(1),
});
export type RestoreInstruction = z.infer<typeof restoreInstructionSchema>;
